
  import { defineComponent, computed, onMounted } from "vue"
  import { useStore } from "vuex"
  import { useRoute } from "vue-router"

  import { Actions } from "@/store/enums/StoreEnums"
  
  import { useAuth0 } from "@auth0/auth0-vue"

  import LayoutNav from "./Nav.vue"
  
  export default defineComponent({
    name: "Layout",
    
    components: {
      LayoutNav
    },
    
    setup() {
      const route = useRoute()
      
      const { isAuthenticated } = useAuth0()

      const currentRouteName = computed(() => {
        return route.meta?.label || route.name
      })

      const hideHeader = computed(() => {
        return !!route.meta?.hideHeader
      })

      return {
        isAuthenticated,
        currentRouteName,
        hideHeader,
        privacyPolicy: process.env.VUE_APP_PRIVACY_POLICY,
        termsAndConditions: process.env.VUE_APP_TERMS_AND_CONDITIONS
      }
    }
  })
